/* Rêvery & Silk — Refonte CRO 2026-09 : mouvement en réponse aux actions + une révélation unique. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Révélation unique (nuancier) : ajoute .is-in une seule fois à l'entrée dans le viewport */
  var reveals = document.querySelectorAll('.rs-reveal');
  if (reveals.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* 1b. Animations en boucle (preuve par la goutte) : jouées seulement quand elles sont à l'écran */
  var players = document.querySelectorAll('.rs3-proof');
  if (players.length && 'IntersectionObserver' in window && !reduce) {
    var pio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('is-playing', e.isIntersecting); });
    }, { threshold: 0.15 });
    players.forEach(function (el) { pio.observe(el); });
  }

  /* 2. Badge panier : petit « pop » quand le nombre d'articles change */
  ['cart-count-badge', 'cart-count-badge-mobile', 'sticky-cart-badge'].forEach(function (id) {
    var b = document.getElementById(id);
    if (!b || !('MutationObserver' in window)) return;
    var last = b.textContent.trim();
    new MutationObserver(function () {
      var now = b.textContent.trim();
      if (now === last) return;
      last = now;
      b.classList.remove('rs-bump');
      void b.offsetWidth; // relance l'animation
      b.classList.add('rs-bump');
    }).observe(b, { childList: true, characterData: true, subtree: true });
  });

  /* 3. Bouton d'ajout : état « ajouté » (couleur moka + pop du libellé) après un ajout réussi */
  document.addEventListener('cart:updated', function () {
    document.querySelectorAll('[data-add-to-cart-btn]').forEach(function (btn) {
      btn.classList.add('rs-added');
      setTimeout(function () { btn.classList.remove('rs-added'); }, 1600);
    });
  });
})();
